/** @format */

import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

export const getHeaderConfig = (loadData, onEdit) => [
  {
    label: "Name",
    id: "name",
  },
  {
    label: "Actions",
    id: "actions",
    render: (data) => {
      return (
        <IconButton onClick={() => onEdit(data)} id="delete" onCL sx={{ p: 0 }}>
          <EditIcon color="primary" />
        </IconButton>
      );
    },
  },
];
